__webpack_require__.p = "https://bmidxbestoniaplpreprod.netlify.app/";